<template>
  <div>
    <!-- 轮播图区域 -->
    <div class="head scroll-animate">
      <div class="carousel">
        <div v-if="bannerLoading" class="skeleton-carousel">
          <div class="skeleton-carousel-item"></div>
        </div>
        <el-carousel v-else style="height: 470px" :interval="5000" arrow="always">
          <el-carousel-item
            v-for="(item, index) in bannerList"
            :key="item.id"
            style="height: 470px"
          >
            <div class="img-box" @click="jumpToDeatil(item.targetId)">
              <el-image
                style="width: 1120px; height: 470px"
                :src="item.bannerUrl"
                fit="cover"
                class="banner-image"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <div class="img-title" :class="{'active': currentBanner === index}">
                {{ item.bannerName }}
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <!-- 团队简介和通知公告 -->
    <div class="middle scroll-animate delay-200">
      <div class="card card-hover" style="width: 500px;">
        <div class="card-title">
          <div class="flex">
            <span class="chinese">团队简介</span>
            <span class="english">About Us</span>
          </div>
        </div>
        <div v-if="teamDetailLoading" class="skeleton-container">
          <div class="skeleton-line"></div>
          <div class="skeleton-line"></div>
          <div class="skeleton-line"></div>
          <div class="skeleton-line"></div>
          <div class="skeleton-line"></div>
        </div>
        <div v-else class="ql-editor content-fade" v-html="teamDetail.description"></div>
      </div>
      <div class="card card-hover" style="margin-left: 20px;width: 500px;">
        <div class="card-title">
          <div class="flex">
            <span class="chinese">通知公告</span>
            <span class="english">Notice</span>
          </div>
          <div class="more" @click="toMore('notice')">更多</div>
        </div>
        <div v-if="noticeListLoading" class="skeleton-container">
          <div class="skeleton-line"></div>
          <div class="skeleton-line"></div>
          <div class="skeleton-line"></div>
          <div class="skeleton-line"></div>
          <div class="skeleton-line"></div>
        </div>
        <div v-else class="card-list">
          <div
            class="item list-item"
            v-for="(item, index) in noticeList"
            :key="item.id"
            v-show="index < 5"
            @click="routerTo(`/detail?id=${item.id}`, item)"
            :style="{animationDelay: `${index * 0.1}s`}"
          >
            <div class="timeLine">
              <div class="title">
                <span><i class="el-icon-d-arrow-right"></i></span>
                <span>{{ item.title }}</span>
              </div>
              <div class="time">
                {{ item.createdTime | formatDate("YYYY-MM-DD") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 学术动态 -->
    <div class="middle scroll-animate delay-300">
      <div class="card card-hover">
        <div class="card-title">
          <div class="flex">
            <span class="chinese">学术动态</span>
            <span class="english">Trends</span>
          </div>
          <div class="more" @click="toMore('Trends')">更多</div>
        </div>
        <div v-if="academicTrendLoading" class="skeleton-container">
          <div class="skeleton-line"></div>
          <div class="skeleton-line"></div>
          <div class="skeleton-line"></div>
          <div class="skeleton-line"></div>
          <div class="skeleton-line"></div>
        </div>
        <div v-else class="card-list">
          <div
            class="item list-item"
            v-for="(item, index) in academicTrendList"
            :key="item.id"
            v-show="index < 5"
            @click="routerTo('/detail', item)"
            :style="{animationDelay: `${index * 0.1}s`}"
          >
            <div style="width: 1100px;">
              <span><i class="el-icon-d-arrow-right"></i></span>
              <span>
                {{ item.title }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 发表论文 -->
    <div class="middle scroll-animate delay-400">
      <div class="card card-hover">
        <div class="card-title">
          <div class="flex">
            <span class="chinese">发表论文</span>
            <span class="english">Publications</span>
          </div>
          <div class="more" @click="routerTo('/publications')">更多</div>
        </div>
        <div v-if="publicationLoading" class="skeleton-container">
          <div class="skeleton-line"></div>
          <div class="skeleton-line"></div>
          <div class="skeleton-line"></div>
          <div class="skeleton-line"></div>
          <div class="skeleton-line"></div>
        </div>
        <div v-else class="card-list">
          <div
            class="item list-item"
            v-for="(item, index) in publicationList"
            :key="item.id"
            v-show="index < 5"
            @click="routerTo(`/publications`)"
            :style="{animationDelay: `${index * 0.1}s`}"
          >
            <div style="width: 1100px;">
              <span><i class="el-icon-d-arrow-right"></i></span>
              <span>
                {{ item.title }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 团队生活 -->
    <div class="bottom scroll-animate delay-500">
      <div class="card card-hover">
        <div class="card-title center">
          <div class="flex">
            <span class="chinese" @click="routerTo('/groupAlbum')">团队生活</span>
            <span class="english">Group Album</span>
          </div>
        </div>
        <div class="card-image">
          <div v-if="teamLifeLoading" class="skeleton-carousel">
            <div class="skeleton-carousel-item" style="height: 330px"></div>
          </div>
          <el-carousel v-else style="height: 330px" type="card">
            <el-carousel-item
              v-for="item in teamLifeList"
              :key="item.id"
            >
              <div class="album-item">
                <el-image
                  style="width: 550px; height: 330px"
                  :src="item.image"
                  fit="cover"
                  @click="routerTo(`/detail`, item)"
                  class="album-image"
                >
                </el-image>
                <div class="album-overlay">
                  <span>查看详情</span>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="links scroll-animate delay-600">
        <div class="title">
          <div class="line"></div>
          <div class="flex" style="padding:0 20px;flex-shrink: 0;">
            <span class="chinese">相关链接</span>
            <span class="english">Related Links</span>
          </div>
          <div class="line"></div>
        </div>
        <div class="el-links">
          <div
            class="link-item"
            v-for="(link, index) in links"
            :key="index"
            @click="to(link.url)"
            :style="{animationDelay: `${index * 0.1}s`}"
          >
            {{ link.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getHomeBannerPage, getTeamDetail, getNoticePage, getTeamLifePage, getPublicationPage, getAcademicTrendPage} from '@/api/api'
import '@/dist/quill.core.css'
import '@/dist/quill.snow.css'
import '@/dist/quill.bubble.css'
export default {
  data () {
    return {
      bannerList: [],
      noticeList: [],
      teamLifeList: [],
      publicationList: [],
      academicTrendList: [],
      teamDetail: {},
      teamDetailLoading: true,
      noticeListLoading: true,
      bannerLoading: true,
      academicTrendLoading: true,
      publicationLoading: true,
      teamLifeLoading: true,
      currentBanner: 0,
      links: [
        { name: '桂电研究生院', url: 'https://www.guet.edu.cn/gra/' },
        { name: '桂电图书馆', url: 'https://www.guet.edu.cn/lib/' },
        { name: '桂电研招网', url: 'https://www.guet.edu.cn/yjszs/' },
        { name: 'NREL', url: 'https://www.nrel.gov/pv/cell-efficiency.html' },
        { name: '桂林电子科技大学学报', url: 'https://xb.guet.edu.cn/' }
      ]
    }
  },
  created () {
    // 先从本地存储加载数据
    this.loadFromLocalStorage()
    // 然后请求新数据
    this.getHomeBannerPage()
    this.getNoticePage()
    this.getTeamLifePage()
    this.getPublicationPage()
    this.getTeamDetail()
    this.getAcademicTrendPage()
  },
  methods: {
    to (http) {
      window.location.href = http
    },
    toMore (type) {
      this.$router.push(
        {path: `/list?type=${type}`}
      )
    },
    routerTo (path, row) {
      if (row) {
        sessionStorage.setItem('detail', JSON.stringify(row))
      }
      this.$router.push({
        path
      })
    },
    loadFromLocalStorage () {
      // 从本地存储加载数据
      const bannerList = localStorage.getItem('bannerList')
      const noticeList = localStorage.getItem('noticeList')
      const teamLifeList = localStorage.getItem('teamLifeList')
      const publicationList = localStorage.getItem('publicationList')
      const academicTrendList = localStorage.getItem('academicTrendList')
      const teamDetail = localStorage.getItem('teamDetail')
      if (bannerList) {
        this.bannerList = JSON.parse(bannerList)
        this.bannerLoading = false
      }
      if (noticeList) {
        this.noticeList = JSON.parse(noticeList)
        this.noticeListLoading = false
      }
      if (teamLifeList) {
        this.teamLifeList = JSON.parse(teamLifeList)
        this.teamLifeLoading = false
      }
      if (publicationList) {
        this.publicationList = JSON.parse(publicationList)
        this.publicationLoading = false
      }
      if (academicTrendList) {
        this.academicTrendList = JSON.parse(academicTrendList)
        this.academicTrendLoading = false
      }
      if (teamDetail) {
        this.teamDetail = JSON.parse(teamDetail)
        this.teamDetailLoading = false
      }
    },
    jumpToDeatil (id) {
      this.$router.push({
        path: `/detail?type=query&id=${id}`
      })
    },
    getAcademicTrendPage () {
      let data = {
        pageSize: 5
      }
      getAcademicTrendPage(data).then(res => {
        if (res.code === 200) {
          this.academicTrendList = res.data.list
          localStorage.setItem('academicTrendList', JSON.stringify(res.data.list))
        }
        this.academicTrendLoading = false
      })
    },
    getHomeBannerPage () {
      let data = {
        pageSize: 5
      }
      getHomeBannerPage(data).then(res => {
        if (res.code === 200) {
          this.bannerList = res.data.list
          localStorage.setItem('bannerList', JSON.stringify(res.data.list))
        }
        this.bannerLoading = false
      })
    },
    getNoticePage () {
      let data = {
        pageSize: 5
      }
      getNoticePage(data).then(res => {
        if (res.code === 200) {
          this.noticeList = res.data.list
          localStorage.setItem('noticeList', JSON.stringify(res.data.list))
        }
        this.noticeListLoading = false
      })
    },
    getPublicationPage () {
      let data = {
        pageSize: 5
      }
      getPublicationPage(data).then(res => {
        if (res.code === 200) {
          this.publicationList = res.data.list
          localStorage.setItem('publicationList', JSON.stringify(res.data.list))
        }
        this.publicationLoading = false
      })
    },
    getTeamLifePage () {
      let data = {
        pageSize: 5
      }
      getTeamLifePage(data).then(res => {
        if (res.code === 200) {
          this.teamLifeList = res.data.list
          localStorage.setItem('teamLifeList', JSON.stringify(res.data.list))
        }
        this.teamLifeLoading = false
      })
    },
    getTeamDetail () {
      getTeamDetail().then(res => {
        if (res.code === 200) {
          this.teamDetail = res.data
          localStorage.setItem('teamDetail', JSON.stringify(res.data))
        }
        this.teamDetailLoading = false
      })
    }
  }
}
</script>

<style scoped>
/* 头部区域 */
.head {
  display: flex;
  animation: fadeIn 0.8s ease-out;
}

.carousel {
  height: 470px;
  width: 1120px;
  flex-shrink: 0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.image-slot {
  width: 1120px;
  height: 470px;
  font-size: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f0;
}

.img-box {
  position: relative;
  background: #fff;
  overflow: hidden;
  cursor: pointer;
}

.banner-image {
  transition: transform 0.5s ease;
}

.img-box:hover .banner-image {
  transform: scale(1.05);
}

.img-title {
  background: linear-gradient(to top, #1A3D3D, transparent);
  position: absolute;
  z-index: 999;
  bottom: 0;
  width: 100%;
  height: 100px;
  font-size: 22px;
  font-weight: 600;
  color: #fff;
  line-height: 130px;
  padding: 0 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 0.3s ease;
  opacity: 0;
  transform: translateY(20px);
}

.img-title.active {
  opacity: 1;
  transform: translateY(0);
}

/* 卡片基础样式 */
.card {
  flex-grow: 1;
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.card-hover:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.12);
}

.card-title {
  height: 40px;
  letter-spacing: 1px;
  font-size: 22px;
  color: #1A3D3D;
  display: flex;
  justify-content: space-between;
  border-bottom: 3px solid #1A3D3D;
  font-weight: bold;
  position: relative;
}

.card-title::after {
  content: '';
  position: absolute;
  bottom: -3px;
  left: 0;
  width: 0;
  height: 3px;
  background: linear-gradient(90deg, #1A3D3D, #D4AF37);
  transition: width 0.6s ease;
}

.card:hover .card-title::after {
  width: 100%;
}

.english {
  font-size: 16px;
  color: #888;
  margin-left: 8px;
}

/* 更多按钮 */
.card .more {
  font-size: 14px;
  line-height: 30px;
  transition: all 0.3s ease;
  cursor: pointer;
  color: #1A3D3D;
  position: relative;
}

.card .more::after {
  content: '';
  position: absolute;
  bottom: 2px;
  left: 0;
  width: 0;
  height: 1px;
  background: #D4AF37;
  transition: width 0.3s ease;
}

.card .more:hover {
  color: #D4AF37;
}

.card .more:hover::after {
  width: 100%;
}

/* 列表项动画 */
.card-list {
  height: 327px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-top: 20px;
  color: #1A3D3D;
  font-size: 15px;
  font-weight: bold;
  box-sizing: border-box;
}

.list-item {
  flex-grow: 1;
  border-bottom: 1px solid #eee;
  opacity: 0;
  transform: translateX(-20px);
  animation: slideInRight 0.5s ease forwards;
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.card .item {
  flex-grow: 1;
  border-bottom: 1px solid #eee;
  transition: all 0.3s ease;
}

.card .item + .item {
  margin-top: 10px;
}

.card .item:hover {
  background: rgba(26, 61, 61, 0.02);
  padding-left: 8px;
}

.card .item:hover span {
  cursor: pointer;
  color: #D4AF37;
}

.card .item span {
  color: #243257;
  transition: all 0.3s ease;
}

/* 内容淡入 */
.content-fade {
  animation: fadeIn 0.6s ease-out;
}

/* 中间区域 */
.middle {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.middle .card-list {
  height: auto;
  padding-top: 0;
}

.middle .card .item {
  padding: 10px 0;
  display: flex;
}

.middle .card .item + .item {
  margin-top: 0px;
}

.middle .card .item span {
  color: #333;
  font-size: 14px;
}

.middle .card .item:hover span {
  cursor: pointer;
  color: #D4AF37;
}

.middle .card .item div {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 底部区域 */
.bottom {
  margin-top: 40px;
}

.bottom .center {
  text-align: center;
  justify-content: center;
}

/* 相册效果 */
.card-image {
  margin-top: 20px;
}

.album-item {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  cursor: pointer;
}

.album-image {
  transition: transform 0.5s ease;
}

.album-item:hover .album-image {
  transform: scale(1.1);
}

.album-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(26, 61, 61, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.3s ease;
}

.album-item:hover .album-overlay {
  opacity: 1;
}

.album-overlay span {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  transform: translateY(20px);
  transition: transform 0.3s ease;
}

.album-item:hover .album-overlay span {
  transform: translateY(0);
}

/* 链接区域 */
.links {
  margin-top: 40px;
}

.links .title {
  height: 40px;
  letter-spacing: 1px;
  font-size: 22px;
  font-weight: bold;
  color: #2f4f4f;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.line {
  height: 3px;
  flex-grow: 1;
  background: linear-gradient(90deg, #2f4f4f, #D4AF37, #2f4f4f);
  background-size: 200% 100%;
  animation: shimmer 3s linear infinite;
}

.el-links {
  font-size: 16px;
  display: flex;
  flex-wrap: wrap;
  padding: 0 80px;
  box-sizing: border-box;
  color: #2f4f4f;
  justify-content: center;
}

.link-item {
  padding: 10px 20px;
  text-align: center;
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
  opacity: 0;
  animation: fadeInUp 0.5s ease forwards;
}

.link-item::after {
  content: '';
  position: absolute;
  bottom: 5px;
  left: 50%;
  width: 0;
  height: 2px;
  background: #D4AF37;
  transition: all 0.3s ease;
  transform: translateX(-50%);
}

.link-item:hover {
  color: #D4AF37;
  transform: translateY(-3px);
}

.link-item:hover::after {
  width: 60%;
}

/* 时间线 */
.timeLine {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.timeLine .title {
  flex-grow: 1;
}

.time {
  color: #888;
  text-align: right;
  width: 100px;
  flex-shrink: 0;
  font-size: 13px;
}

/* 骨架屏样式 */
.skeleton-container {
  padding: 20px 0;
}

.skeleton-line {
  height: 16px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s ease-in-out infinite;
  margin-bottom: 12px;
  border-radius: 4px;
}

.skeleton-line:nth-child(1) { width: 80%; }
.skeleton-line:nth-child(2) { width: 90%; }
.skeleton-line:nth-child(3) { width: 85%; }
.skeleton-line:nth-child(4) { width: 95%; }
.skeleton-line:nth-child(5) { width: 75%; }

@keyframes skeleton-loading {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* 轮播图骨架屏样式 */
.skeleton-carousel {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.skeleton-carousel-item {
  width: 1120px;
  height: 470px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s ease-in-out infinite;
  border-radius: 8px;
}

/* 响应式动画 */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
</style>
